/** @format */

import {useState} from 'react';

import {Unstable_Popup as BasePopup} from '@mui/base/Unstable_Popup';
import FilterListIcon from '@mui/icons-material/FilterList';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';

import PopupBody from './PopupBody';

const ExceptionIconWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  background: '#383838',
}));

interface Props {
  name: string;
  hasExceptions: boolean;
}

const SensorNameCell = ({name, hasExceptions}: Props) => {
  const {t} = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const [text, setText] = useState('');

  const handleOpen = (event: React.MouseEvent<HTMLElement>, value: string) => {
    setAnchor(event.currentTarget);
    setText(value);
  };

  const handleClose = () => setAnchor(null);

  return (
    <Box
      sx={{
        position: 'relative',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{width: '94%', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
        onMouseEnter={event => handleOpen(event, name)}
        onMouseLeave={handleClose}
      >
        {name}
      </Box>

      {hasExceptions && (
        <ExceptionIconWrapper
          onMouseEnter={event => handleOpen(event, t('В сенсор добавлены исключения'))}
          onMouseLeave={handleClose}
        >
          <FilterListIcon sx={{color: '#F1F1F1', fontSize: '16px'}} />
        </ExceptionIconWrapper>
      )}

      <BasePopup open={Boolean(anchor && text)} anchor={anchor}>
        <PopupBody>{text}</PopupBody>
      </BasePopup>
    </Box>
  );
};

export default SensorNameCell;
